import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { PageLoader } from "@/components/common/Loading";
import { OwnershipDeck } from "@/components/ownership/OwnershipDeck";
import { toast } from "sonner";

const LABEL = { retail: "Retail Traditional", acquisition: "Agency Acquisition", associate: "Associate", protege: "Protégé" };

export default function PresentOwnership() {
  const { pid } = useParams();
  const nav = useNavigate();
  const [deck, setDeck] = useState(null);
  const [err, setErr] = useState(null);
  const back = () => nav(`/people/detail/${pid}`);
  useEffect(() => { api.get(`/ownership-deck/person/${pid}`).then((r) => setDeck(r.data)).catch((e) => setErr(apiError(e))); }, [pid]);
  if (err) return <div className="p-8 text-slate-600" data-testid="ao-present-error">{err} <button className="underline" onClick={back}>Back</button></div>;
  if (!deck) return <PageLoader label="Loading presentation" />;
  const banner = (
    <div className="mb-4 flex flex-wrap items-center justify-between gap-2 rounded-xl bg-amber-50 px-4 py-2 text-sm text-amber-900" data-testid="ao-present-banner">
      <span>Presenting to <b>{deck.person_name || "Candidate"}</b> · Pathway: <b>{LABEL[deck.pathway] || "Not yet assigned"}</b></span>
      <button className="font-semibold underline" onClick={back} data-testid="ao-present-back">Back to Candidate record</button>
    </div>
  );
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 py-8" data-testid="ao-present-page">
      <OwnershipDeck deck={deck} notes autoStart onExitPresenter={back} onAction={(u) => { if (/^https?:\/\//.test(u)) window.open(u, "_blank", "noopener,noreferrer"); else toast.info("This button takes the Candidate to their own portal page."); return false; }} banner={banner} />
    </div>
  );
}
